import React from 'react';
import PropTypes from 'prop-types';
import { connectStateResults } from 'react-instantsearch-dom';
import SourceRequestSkeletonPage from '../index/source_request_skeleton_page';

function SearchLoadingCards({ searchResults, smallMode }) {
  const isLoading = !searchResults;

  if (!isLoading) return null;

  return (
    <SourceRequestSkeletonPage numberOfCards={12} smallMode={smallMode} />
  );
}

SearchLoadingCards.propTypes = {
  searchResults: PropTypes.instanceOf(Object),
  smallMode: PropTypes.bool,
};

SearchLoadingCards.defaultProps = {
  searchResults: undefined,
  smallMode: false,
};

export default connectStateResults(SearchLoadingCards);
